import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl} from "datasync-core";
import { globals, GetDatasyncMediaOneBlockSynchronously2} from "../Components/Globals/Globals";
import { SyncDeleteSynchronously} from "datasync-core";
import { produce } from 'immer';

const initialState = {
  toolboxPartnersItems: [],
  toolboxPartnerCount:0,
  loadToolboxPartners_result:{status: 'idle', error: null},
  deleteToolboxPartners_result:{status: 'idle', error: null},
}

// Create an async thunk for loading articles
export const loadToolboxPartners = createAsyncThunk(
  'toolbox/loadToolboxPartners',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously2({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.toolbox_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter partners
        table_guid: globals.datasync.tbx_partners_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadToolboxPartners::toolbox response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting toolbox partners
export const deleteToolboxPartners = createAsyncThunk(
  'toolbox/deleteToolboxPartners',
  async (deletedToolboxPartnerObject) => {
    try {
      console.clear()
      console.log("deletedToolboxPartnerObject->", deletedToolboxPartnerObject)
      //Delete ToolboxPartner from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedToolboxPartnerObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deletedToolboxPartners->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedToolboxPartnerObject.rejectWithValue(error.message);
    }
  }
);

const toolboxSlice = createSlice({
  name: 'toolbox',
  initialState,
  reducers: {
    addToolboxPartner(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addToolboxPartner: ", state.toolboxPartnersItems)
          console.log("addToolboxPartner: ", state.toolboxPartnerCount)
          console.log("addToolboxPartner::action ->", action)  
        }
  
        state.toolboxPartnerCount++;
        state.toolboxPartnersItems.push(action.payload);
      } catch (error) {
        console.error("ToolboxPartner added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateToolboxPartner(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedToolboxPartnerObject = draft.toolboxPartnersItems.find((toolboxPartner) => toolboxPartner.data_guid === action.payload.data_guid)
        console.log("updateToolboxPartner: updatedToolboxPartnerObject->", updatedToolboxPartnerObject)
        if (updatedToolboxPartnerObject) {
          //update toolboxPartner in the array
          updatedToolboxPartnerObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateToolboxPartner: ToolboxPartner not found in the array");
        }
      })
    },

    revertAllToolboxPartners(state){
      if (globals.parameters.debugging)
        console.log("toolboxSlice revertAllToolboxPartners");
      state.toolboxPartnersItems = [];
      state.toolboxPartnerCount = 0;
      state.loadToolboxPartners_result = {status: 'idle', error: null};
      state.deleteToolboxPartners_result = {status: 'idle', error: null};
    },

    revertStatusToolboxPartners(state){
      if (globals.parameters.debugging)
        console.log("revertStatusToolboxPartners")

      state.deleteToolboxPartners_result = {status: 'idle', error: null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadToolboxPartner */
      .addCase(loadToolboxPartners.pending, (state, action) => {
        state.loadToolboxPartners_result = {status : "loading",error : null};
      })
      .addCase(loadToolboxPartners.fulfilled, (state, action) => {
        try {
          if (action.payload.length > 0) {
            state.loadToolboxPartners_result = {status : "succeeded",error : null};
            state.toolboxPartnersItems = action.payload;
            state.toolboxPartnerCount = action.payload.length;
          }
          else {
            throw("None partners returned !")
          }            
        } catch (error) {
          console.error(`loadToolboxPartner raises -> ${error}`)
          state.loadToolboxPartners_result = {status : "succeeded",error : "No articles found !!!"};
          state.toolboxPartnersItems = [];
          state.toolboxPartnerCount = 0;            
        }}
    )
      .addCase(loadToolboxPartners.rejected, (state, action) => {
        state.loadToolboxPartners_result = {status : "failed",error : action.payload};
      })

      /* deleteToolboxPartners */
      .addCase(deleteToolboxPartners.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteToolboxPartners.pending")
        console.log("deleteToolboxPartners.pending -> action", action)
        state.deleteToolboxPartners_result = {status : "deleting",error : null};
      })
      .addCase(deleteToolboxPartners.fulfilled, (state,action) => {
        //ToolboxPartners sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteToolboxPartners.fulfilled")
          console.log("deleteToolboxPartners.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete toolboxPartners from local state
          draft.toolboxPartnersItems = draft.toolboxPartnersItems.filter((toolboxPartners, j) => toolboxPartners.data_guid !== action.payload.data_guid)
          draft.toolboxPartnerCount--;

          draft.deleteToolboxPartners_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteToolboxPartners.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteToolboxPartners.rejected")
          console.log("deleteToolboxPartners.rejected -> action", action)
        state.deleteToolboxPartners_result = {status : "failed",error : action.payload};
      })
    },
});

export const { revertAllToolboxPartners, addToolboxPartner, updateToolboxPartner, revertStatusToolboxPartners } = toolboxSlice.actions;
export default toolboxSlice.reducer;